import * as ActionTypes from './index';
import {actionCreator} from "../helpers/functions";

export const getApplicationPolicyIPID = actionCreator(ActionTypes.GET_APPLICATION_POLICY_IPID);
export const getApplicationPolicyIPIDSuccess = actionCreator(ActionTypes.GET_APPLICATION_POLICY_IPID_SUCCESS);
export const getApplicationPolicyIPIDFailed = actionCreator(ActionTypes.GET_APPLICATION_POLICY_IPID_FAILED);

//action that requests the policy wording
export function getApplicationPolicyWording(payload) {
    return {
        type: ActionTypes.GET_APPLICATION_POLICY_WORDING,
        payload: payload
    }
}

//action that receives the application wording
export function getApplicationPolicyWordingSuccess(payload) {
    return {
        type: ActionTypes.GET_APPLICATION_POLICY_WORDING_SUCCESS,
        payload: payload
    }
}

//action that receives error getting the application wording
export function getApplicationPolicyWordingFail(payload) {
    return {
        type: ActionTypes.GET_APPLICATION_POLICY_WORDING_FAIL,
        payload: payload
    }
}

//action that requests get application policy after ad creation
export function getApplicationPolicyAfterAdCreate(payload) {
    return {
        type: ActionTypes.GET_APPLICATION_POLICY_AFTER_AD_CREATE,
        payload: payload
    }
}

export function changeActiveTab(tab) {
	return {
		type: ActionTypes.CHANGE_ACTIVE_TAB,
		payload: tab
	}
}

export function downloadFile(fileUrl) {
	return {
		type: ActionTypes.DOWNLOAD_FILE,
		payload: fileUrl
	}
}

//action  that requests to delete a document in the documents tab IF a user i logged in
export function requestDeleteDocument(applicationId, attachmentId, relativeUrl) {
	return {
		type: ActionTypes.REQUEST_DELETE_DOCUMENT,
		payload: {
			applicationId: applicationId,
			attachmentId: attachmentId,
            relativeUrl
		}
	}
}

//action that receives request to delete a document response
export function receiveDeleteDocumentResponse(attachmentId, response) {
	return {
		type: ActionTypes.RECEIVE_DELETE_DOCUMENT_RESPONSE,
		payload: {
			response,
			attachmentId
		}
	}
}

//action that receives failed request to delete a document
export function receiveBadRequestDeleteDocument(response) {
	return {
		type: ActionTypes.RECEIVE_BAD_REQUEST_DELETE_DOCUMENT,
		payload: response
	}
}

//action to handle the state of the users overview tab checkboxes
export function checkUserOverviewTabCheckBox(checkboxId) {
	return {
		type: ActionTypes.CHECK_USER_OVERVIEW_TAB_CHECKBOX,
		payload: checkboxId
	}
}

export function changeApplicationPolicySettings(setting, value) {
	return {
		type: ActionTypes.CHANGE_APPLICATION_POLICY_SETTINGS,
		payload: {
			key: setting,
			value: value
		}
	}
}

export function transferApplicationBetweenSolicitorUsers(setting, value) {
	return {
		type: ActionTypes.TRANSFER_APPLICATION_BETWEEN_SOLICITOR_USERS,
		payload: {
			key: setting,
			value: value
		}
	}
}

export function requestPatchTransferApplicationBetweenSolicitors(body) {
	return {
		type: ActionTypes.REQUEST_PATCH_TRANSFER_APPLICATION_BETWEEN_SOLICITOR_USERS,
		payload: body
	}
}

export function receivePatchTransferApplicationBetweenSolicitors(response) {
	return {
		type: ActionTypes.RECEIVE_PATCH_TRANSFER_APPLICATION_BETWEEN_SOLICITOR_USERS,
		payload : response
	}
}

export function receiveBadRequestPatchTransferApplicationBetweenSolicitors(response) {
	return {
		type: ActionTypes.RECEIVE_BAD_REQUEST_PATCH_TRANSFER_APPLICATION_BETWEEN_SOLICITOR_USERS,
		payload : response
	}
}


//function that requests get all application attachments
export function requestGetAllApplicationAttachments(applicationId) {
	return {
		type: ActionTypes.REQUEST_GET_ALL_APPLICATION_ATTACHMENTS,
		payload: applicationId

	}
}

//function that receives all application attachments
export function receiveAllApplicationAttachments(response) {
	return {
		type: ActionTypes.RECEIVE_ALL_APPLICATION_ATTACHMENTS,
		payload: response
	}
}

//action that receives failed response from getting all application attachments
export function failedToGetAllApplicationAttachments(response) {
	return {
		type: ActionTypes.FAILED_TO_GET_ALL_APPLICATION_ATTACHMENTS,
		payload: response
	}
}


export function requestApplicationPremiumSettings(payload) {
	return {
		type: ActionTypes.REQUEST_APPLICATION_PREMIUM_SETTINGS,
		payload
	}
}

export function receiveApplicationPremiumSettings(payload) {
	return {
		type: ActionTypes.RECEIVE_APPLICATION_PREMIUM_SETTINGS,
		payload
	}
}

export function receiveBadRequestApplicationPremiumSettings(payload) {
	return {
		type: ActionTypes.RECEIVE_BAD_REQUEST_APPLICATION_PREMIUM_SETTINGS,
		payload
	}
}


export function requestPostApplicationPremiumSettings(payload) {
	return {
		type: ActionTypes.REQUEST_POST_APPLICATION_PREMIUM_SETTINGS,
		payload
	}
}

export function receivePostApplicationPremiumSettings(payload) {
	return {
		type: ActionTypes.RECEIVE_POST_APPLICATION_PREMIUM_SETTINGS,
		payload
	}
}

export function receiveBadRequestPostApplicationPremiumSettings(payload) {
	return {
		type: ActionTypes.RECEIVE_BAD_REQUEST_POST_APPLICATION_PREMIUM_SETTINGS,
		payload
	}
}


export function requestPatchApplicationPremiumSettings(payload) {
	return {
		type: ActionTypes.REQUEST_PATCH_APPLICATION_PREMIUM_SETTINGS,
		payload
	}
}

export function receivePatchApplicationPremiumSettings(payload) {
	return {
		type: ActionTypes.RECEIVE_PATCH_APPLICATION_PREMIUM_SETTINGS,
		payload
	}
}

export function receiveBadRequestPatchApplicationPremiumSettings(payload) {
	return {
		type: ActionTypes.RECEIVE_BAD_REQUEST_PATCH_APPLICATION_PREMIUM_SETTINGS,
		payload
	}
}


export function requestDeleteApplicationPremiumSettings(payload) {
	return {
		type: ActionTypes.REQUEST_DELETE_APPLICATION_PREMIUM_SETTINGS,
		payload
	}
}

export function receiveDeleteApplicationPremiumSettings(payload) {
	return {
		type: ActionTypes.RECEIVE_DELETE_APPLICATION_PREMIUM_SETTINGS,
		payload
	}
}

export function receiveBadRequestDeleteApplicationPremiumSettings(payload) {
	return {
		type: ActionTypes.RECEIVE_BAD_REQUEST_DELETE_APPLICATION_PREMIUM_SETTINGS,
		payload
	}
}

export function receivePatchApplicationAfterPremium(payload) {
	return {
		type: ActionTypes.RECEIVE_PATCH_APPLICATION_AFTER_PREMIUM,
		payload
	}
}

export function receiveBadRequestPatchApplicationAfterPremium(payload) {
	return {
		type: ActionTypes.RECEIVE_BAD_REQUEST_PATCH_APPLICATION_AFTER_PREMIUM_SETTINGS,
		payload
	}
}

export function changeAppPremiumSettingsField(key, value) {
	return {
		type: ActionTypes.CHANGE_APP_PREMIUM_SETTINGS_FIELD,
		payload: {
			key,
			value
		}
	}
}

//action that changes the selected damages in the store
export function changeSubSettingsDamages(subSettingId, damageField, damageValue) {
	return {
		type: ActionTypes.CHANGE_SUB_SETTING_DAMAGES,
		payload: {
			subSettingId,
			damageField,
			damageValue
		}
	}
}


//action that changes the selected sub setting
export function changeSubSetting(subSettingId, damageField, damageValue) {
	return {
		type: ActionTypes.CHANGE_SUB_SETTING,
		payload: {
			subSettingId,
			damageField,
			damageValue
		}
	}
}

//action that requests Get Solicitor Group By Id
export function requestGetSolicitorGroupOfApplication(groupId) {
	return {
		type: ActionTypes.REQUEST_GET_SOLICITOR_GROUP_OF_APPLICATION,
		payload: groupId
	}
}

//action that receives Solicitor Group By Id
export function receiveGetSolicitorGroupOfApplication(group) {
	return {
		type: ActionTypes.RECEIVE_GET_SOLICITOR_GROUP_OF_APPLICATION,
		payload: group
	}
}

//failed to receive solicitor group by id
export function failedToReceiveSolicitorGroupOfApplication(response) {
	return {
		type: ActionTypes.FAILED_TO_RECEIVE_SOLICITOR_GROUP_OF_APPLICATION,
		payload:response
	}
}



//premium setting: action that changes settings for the combination of damage band and case stage
export function changeApplicationPremiumSettingsWizardStoreByDamageAndCaseStage(field, value, tableIndex){
	return {
		type: ActionTypes.CHANGE_APPLICATION_PREMIUM_SETTINGS_WIZARD_STORE_BY_DAMAGE_AND_CASE_STAGE,
		payload: {
			field,
			value,
			tableIndex
		}
	}
}

//premium setting: action that changes settings for the combination of damage band , case stage and solicitor
export function changeApplicationPremiumSettingsWizardStoreByDamageCaseStageAndSolicitor(field, value , tableIndex, solicitorIndex){
	return {
		type: ActionTypes.CHANGE_APPLICATION_PREMIUM_SETTINGS_WIZARD_STORE_BY_DAMAGE_CASE_STAGE_AND_SOLICITOR,
		payload: {
			field,
			value,
			tableIndex,
			solicitorIndex
		}
	}
}



//action  that requests to delete a document in the documents tab IF a user i logged in
export function requestApplicationAttachment(payload) {
	return {
		type: ActionTypes.REQUEST_APPLICATION_ATTACHMENT,
		payload
	}
}

//action that receives request to delete a document response
export function receiveApplicationAttachment(payload) {
	return {
		type: ActionTypes.RECEIVE_APPLICATION_ATTACHMENT,
		payload
	}
}

//action that receives failed request to delete a document
export function failedToGetApplicationAttachment(payload) {
	return {
		type: ActionTypes.RECEIVE_BAD_REQUEST_APPLICATION_ATTACHMENT,
		payload
	}
}

/********************APPLICATION NOTIFICATION******************/


export function requestApplicationNotification(payload) {
	return {
		type: ActionTypes.REQUEST_GET_APPLICATION_NOTIFICATION,
		payload
	}
}

export function receiveApplicationNotification(payload) {
	return {
		type: ActionTypes.RECEIVE_GET_APPLICATION_NOTIFICATION,
		payload
	}
}

export function receiveFailureApplicationNotification(payload) {
	return {
		type: ActionTypes.RECEIVE_FAILURE_GET_APPLICATION_NOTIFICATION,
		payload
	}
}
export function getPolicySchedule(payload) {
	return {
		type: ActionTypes.GET_POLICY_SCHEDULE,
		payload
	}
}
export function receivePolicySchedule(payload) {
	return {
		type: ActionTypes.RECEIVE_GET_POLICY_SCHEDULE,
		payload
	}
}

export function failGetPolicySchedule(payload) {
	return {
		type: ActionTypes.FAIL_GET_POLICY_SCHEDULE,
		payload
	}
}
